module.exports = __webpack_public_path__ + "img/1.7359b957.png";